import getIntervalUnits from 'utils/getIntervalUnits';

import FormGrid from 'components/FormGrid';
import ServiceIntervalField from 'components/fields/ServiceIntervalField';

import usePartTypeLabels from 'hooks/usePartTypeLabels';

import useTranslation from './hooks/useTranslation';

import { INTERVALS_FIELD_NAME, TEST_ID, UNITS_FIELD_NAME } from './constants';
import type { FunctionComponent, Props, ServiceIntervalsFormSchema } from './types';

import styles from './styles.module.scss';

const ServiceIntervalFields: FunctionComponent<Props> = ({
    className = '',
    control,
    isDisabled = false,
    parts,
    testId = TEST_ID
}) => {
    const { getPartTypeLabel } = usePartTypeLabels();

    const { OEM_DEFAULT, RESET_TO_DEFAULT, UNIT_LABELS, UNIT_NAMES } = useTranslation();

    return (
        <FormGrid className={`${className} ${styles.serviceIntervalFields}`} testId={testId}>
            {parts.map(part => {
                const oemLabel = OEM_DEFAULT({
                    value: `${part.defaultIntervalValue} ${UNIT_NAMES[part.defaultIntervalUnit]}`
                });

                const units = getIntervalUnits({ partType: part.partType }).map(unit => ({
                    label: UNIT_LABELS[unit],
                    value: unit
                }));

                return (
                    <ServiceIntervalField<ServiceIntervalsFormSchema>
                        control={control}
                        defaultIntervalUnit={part.defaultIntervalUnit}
                        defaultIntervalValue={part.defaultIntervalValue}
                        isDisabled={isDisabled}
                        key={part.assetModelPartId}
                        label={getPartTypeLabel(part.partType)}
                        oemLabel={oemLabel}
                        resetLabel={RESET_TO_DEFAULT}
                        unitLabel={UNIT_NAMES[part.effectiveIntervalUnit]}
                        unitName={`${UNITS_FIELD_NAME}.${part.assetModelPartId}`}
                        units={units}
                        valueName={`${INTERVALS_FIELD_NAME}.${part.assetModelPartId}`}
                    />
                );
            })}
        </FormGrid>
    );
};

export default ServiceIntervalFields;
